import React, { useState } from 'react';
import { Button, Input, message } from 'antd';
import { teamsApi } from '../../api/teams';
import './TeamRoles.css';

function TeamRoles({ team, onTeamUpdate }) {
	const [newRoleName, setNewRoleName] = useState('');
	const [isAddingRole, setIsAddingRole] = useState(false);

	const handleAddRole = async () => {
		try {
			if (!newRoleName.trim()) {
				message.error('Role name is required');
				return;
			}

			const order = team.roles ? team.roles.length : 0;
			const response = await teamsApi.createRole(team.id, {
				name: newRoleName.trim(),
				order,
			});

			// Fetch fresh team data after role creation
			const teamData = await teamsApi.getTeam(team.id);
			onTeamUpdate(teamData.team);

			setNewRoleName('');
			setIsAddingRole(false);
			message.success('Role added successfully');
		} catch (error) {
			console.error('Error adding role:', error);
			message.error('Failed to add role');
		}
	};

	const handleDeleteRole = async (roleId) => {
		try {
			await teamsApi.deleteRole(team.id, roleId);
			// Fetch fresh team data after role deletion
			const teamData = await teamsApi.getTeam(team.id);
			onTeamUpdate(teamData.team);
			message.success('Role deleted successfully');
		} catch (error) {
			console.error('Error deleting role:', error);
			message.error('Failed to delete role');
		}
	};

	return (
		<div className='detail-card'>
			<div className='section-header'>
				<h2>Team Roles</h2>
				{!isAddingRole && (
					<Button
						type='primary'
						onClick={() => setIsAddingRole(true)}
						icon={<span className='material-icons'>add</span>}>
						Add Role
					</Button>
				)}
			</div>

			{isAddingRole && (
				<div className='add-role-form'>
					<Input
						placeholder='Role name'
						value={newRoleName}
						onChange={(e) => setNewRoleName(e.target.value)}
					/>
					<div className='form-actions'>
						<Button onClick={() => setIsAddingRole(false)}>
							Cancel
						</Button>
						<Button
							type='primary'
							onClick={handleAddRole}>
							Save Role
						</Button>
					</div>
				</div>
			)}

			<div className='roles-grid'>
				{team.roles?.length > 0 ? (
					team.roles.map((role) => (
						<div
							key={role.id}
							className='role-card'>
							<h3>{role.name}</h3>
							<Button
								type='text'
								danger
								className='delete-role-button'
								onClick={() => handleDeleteRole(role.id)}
								icon={
									<span className='material-icons'>
										delete
									</span>
								}
							/>
						</div>
					))
				) : (
					<div className='no-roles-message'>
						No roles defined for this team
					</div>
				)}
			</div>
		</div>
	);
}

export default TeamRoles;
